import { render, staticRenderFns } from "./SpeakersBlock.vue?vue&type=template&id=3676c1eb"
import script from "./SpeakersBlock.vue?vue&type=script&lang=ts"
export * from "./SpeakersBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports